import React from "react";
import SEO from "../components/SEO";
import { FileText } from "lucide-react";

const Terms = () => (
  <div className="relative min-h-screen bg-[#0B0F19] text-white">
    <SEO title="Terms of Service - QryptShield" />
    <div className="absolute inset-0 z-0 pointer-events-none">
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #ffffff60 1px, transparent 1px), linear-gradient(to bottom, #ffffff60 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[450px] bg-blue-600/20 rounded-[100%] blur-[120px]" />
    </div>

    <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-10">
      <div className="space-y-3 text-center mt-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-300 text-xs font-semibold">
          <FileText className="w-4 h-4" /> Terms of Service
        </div>
        <h1 className="text-4xl font-bold">Use of QryptShield</h1>
        <p className="text-gray-400 max-w-3xl mx-auto">
          These terms outline acceptable use, account responsibilities, and our
          commitment to reliable, secure service.
        </p>
      </div>

      <div className="bg-white/5 border border-white/10 rounded-2xl p-8 space-y-6 shadow-xl">
        {[
          {
            title: "Account Responsibility",
            body: "Keep credentials confidential. Notify us immediately of suspected compromise so we can revoke keys and tokens.",
          },
          {
            title: "Acceptable Use",
            body: "No illegal activity, abuse, spam, or attempts to break or bypass the service. We may suspend accounts for violations.",
          },
          {
            title: "Service Availability",
            body: "We target high availability with proactive monitoring and maintenance windows announced in advance when possible.",
          },
          {
            title: "Updates",
            body: "We may update the client or server software to improve security and performance. Continued use signifies acceptance of updates.",
          },
          {
            title: "Liability",
            body: "Service is provided as-is to the extent permitted by law. Our liability is limited to fees paid for the current term.",
          },
        ].map((item) => (
          <div key={item.title} className="space-y-2">
            <h2 className="text-xl font-semibold text-white">{item.title}</h2>
            <p className="text-gray-300 text-sm leading-relaxed">{item.body}</p>
          </div>
        ))}
      </div>

      <div className="bg-gradient-to-r from-gray-900 to-blue-900/30 border border-white/10 rounded-2xl p-6 text-center space-y-3">
        <h3 className="text-xl font-bold">Need clarifications?</h3>
        <p className="text-gray-400 text-sm">
          Contact info@qryptshield.com. We are happy to discuss specific
          deployment requirements.
        </p>
      </div>
    </div>
  </div>
);

export default Terms;
